import React, { PropTypes } from 'react';

import { NitroHeading, NitroButton, NitroParagraph, NitroPanel } from 'nitro-components';

import styled from 'styled-components';
import Container from '../../../../components/layouts/Container';

import Breakpoint from '../../../../utils/breakpoints';
import { media } from 'style-utils';

const FixedPanelWrapper = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 16px;
  left: 0;
  right: 0;
  ${media.mobileTablet`
    bottom: 66px;
  `}
`;

const Content = styled.div`
  display: flex;
`;

const TermItem = styled.div`
  flex: 1;
  line-height: 20px;
`;

const TermItemRight = TermItem.extend`
  flex: none;
`;

const Terms = ({ vehicle, estimatedCost, actionHandler, disabled, updatingQuote, term, distance, calculating }) => {
  let termKm = Number(distance);
  termKm = termKm.toLocaleString();

  const estimate = estimatedCost ? `${estimatedCost}/mo` : '-';

  return (
    <FixedPanelWrapper>
      <Container>
        <NitroPanel padding="16px" dark noMargin>
          <Content>

            <TermItem>
              <NitroHeading label="Vehicle" size="4" variant="primary" noMargin />
               <NitroParagraph variant="white" noMargin>{vehicle.MakeName} {vehicle.ModelName}</NitroParagraph>
            </TermItem>

            <Breakpoint name="tabletDesktop">
              <TermItem>
                <NitroHeading label="Terms" size="4" variant="primary" noMargin />
                <NitroParagraph variant="white" noMargin>{term} Months - {termKm}km</NitroParagraph>
              </TermItem>
            </Breakpoint>

            <TermItem>
              <NitroHeading label="Estimated cost" size="4" variant="primary" noMargin />
              <NitroParagraph variant="white" noMargin>
                {calculating ? 'Calculating...' : estimate}
              </NitroParagraph>
            </TermItem>

            <TermItemRight>
              <NitroButton
                size="small"
                loading={updatingQuote || calculating}
                label="Next"
                variant="primary"
                disabled={disabled}
                action={actionHandler}
              />
            </TermItemRight>

          </Content>
        </NitroPanel>
      </Container>
    </FixedPanelWrapper>
  );
};

Terms.propTypes = {
  disabled: PropTypes.bool,
  calculating: PropTypes.bool,
  actionHandler: PropTypes.func,
  estimatedCost: PropTypes.number,
  updatingQuote: PropTypes.bool,
  distance: PropTypes.string,
  term: PropTypes.string,
  vehicle: PropTypes.object.isRequired
};

export default Terms;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/Terms.js